import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({ name: 'gridDatePipe', standalone: true })
export class gridDatePipe implements PipeTransform {
  transform(value: any) {
    if (value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
    }

    return '-';
  }
}
